import {
  DEFAULT_TOAST_DURATION_MS,
  ToastVariant,
} from "components/designV2/toast/toast";
import { ToastDispatch } from "./toastStore";

export interface ShowToastOptions {
  readonly message: string;
  readonly variant?: ToastVariant;
  readonly title?: string;
  /** Milliseconds the toast is shown, or null to keep it until dismissed. */
  readonly durationMs?: number | null;
}

let toastId = 0;

const showToast =
  (dispatch: ToastDispatch) =>
  ({
    message,
    variant = "info",
    title,
    durationMs = DEFAULT_TOAST_DURATION_MS,
  }: ShowToastOptions): string => {
    toastId += 1;
    const id = `toast-${toastId}`;

    dispatch({
      type: "SHOW_TOAST",
      payload: { id, message, variant, title, durationMs },
    });

    return id;
  };

const dismissToast = (dispatch: ToastDispatch) => (id: string) => {
  dispatch({ type: "DISMISS_TOAST", payload: { id } });
};

export const toastActions = (dispatch: ToastDispatch) => ({
  showToast: showToast(dispatch),
  dismissToast: dismissToast(dispatch),
});
